import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
  },
  frame: {
    flex: 1,
    width: '100%',
    height: '100%',
    minHeight: 0,
    border: 'none',
    backgroundColor: tokens.colorNeutralBackground1,
  },
});
